import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from '@material-ui/core'
import WorkIcon from '@material-ui/icons/Work'
import Skeleton from '@material-ui/lab/Skeleton'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import formatMoney from '../../../../../helpers/formatMoney'
import useIsBadScreenSize from '../../../../../helpers/useIsBadScreenSize'
import checkIsNoData from '../../../../../helpers/checkIsNoData'

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  iconButton: {
    color: 'white'
  },
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
    //fontSize: isBadScreenSize ? '10px' : 'initial'
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.error.dark
  },
  differenceValue: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1)
  }
}))

const AverageConfirmedBooking = props => {
  const isBadScreenSize = useIsBadScreenSize()
  const classes = useStyles()
  const { className, ...rest } = props

  const averageDefiniteBookingValue = useSelector(state =>
    formatMoney(state.bookingInfo.averageOrderValue)
  )
  const averageDefiniteBookingValueText = useSelector(
    state => state.language.text.averageDefiniteBookingValue
  )
  const averageDefiniteBookingValueTooltip = useSelector(
    state => state.language.text.averageDefiniteBookingValueTooltip
  )

  const noDataToDisplayText = useSelector(
    state => state.language.text.noDataToDisplay
  )

  const isNoData = checkIsNoData(averageDefiniteBookingValue)

  const isLoading = useSelector(state => state.bookingInfo.isLoading)
  if (isLoading) {
    return (
      <>
        <Box width="100%" height="96px">
          <Skeleton variant="rect" height="50%"></Skeleton>
          <Skeleton height="10%" />
          <Skeleton height="10%" width="60%" />
        </Box>
      </>
    )
  }

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justify="space-between">
          <Grid item>
            <Tooltip title={averageDefiniteBookingValueTooltip}>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body2"
                style={{ fontSize: isBadScreenSize ? '10px' : '12px' }}>
                {averageDefiniteBookingValueText}
              </Typography>
            </Tooltip>

            <Typography variant={!isBadScreenSize ? 'h3' : 'h4'}>
              {!isNoData ? averageDefiniteBookingValue : noDataToDisplayText}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <IconButton className={classes.iconButton}>
                <WorkIcon className={classes.icon}></WorkIcon>
              </IconButton>
            </Avatar>
          </Grid>
        </Grid>
        {
          //     duration !== 'Custom' ? (
          //   <div className={classes.difference}>
          //     <ArrowDownwardIcon className={classes.differenceIcon} />
          //     <Typography className={classes.differenceValue} variant="body2">
          //       {confirmedBookingValueSupport}%
          //     </Typography>
          //     <Typography className={classes.caption} variant="caption">
          //       Since last month
          //     </Typography>
          //   </div>
          // ) : (
          //   <div className={classes.difference}>
          //     {/* <Typography className={classes.caption} variant="caption">
          //     Choose fixed duration to show more analytics
          //   </Typography> */}
          //   </div>
          // )
        }
      </CardContent>
    </Card>
  )

  // return (
  //   <AverageCard
  //     title={averageDefiniteBookingValueText}
  //     number={`€${formatMoney(averageDefiniteBookingValue)}`}
  //     icon={
  // <Avatar className={classes.avatar}>
  //   <IconButton className={classes.iconButton}>
  //     <WorkIcon className={classes.icon}></WorkIcon>
  //   </IconButton>
  // </Avatar>
  //     }></AverageCard>
  // )
}

AverageConfirmedBooking.propTypes = {
  className: PropTypes.string
}

export default AverageConfirmedBooking
